import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-text-right" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "tw-text-xl tw-font-bold tw-uppercase" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "tw-text-xl tw-font-bold tw-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewAsSomeoneElse = _resolveComponent("ViewAsSomeoneElse")!
  const _component_LoginModal = _resolveComponent("LoginModal")!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$userLoadStatus.value == 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.currentUser !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
                    class: "tw-no-underline"
                  }, " Logout ")
                ]),
                _createVNode(_component_ViewAsSomeoneElse)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.isLoginVisible)
                  ? (_openBlock(), _createBlock(_component_LoginModal, {
                      key: 0,
                      onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLogin(false)))
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_SfRouterLink, {
                    to: "/register",
                    class: "tw-no-underline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Register ")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" / "),
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showLogin(true)), ["prevent"])),
                    class: "tw-no-underline"
                  }, " Login ")
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}